import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CopyShiftTimesFromUnitMutationCgResponse,
  CopyShiftTimesFromUnitMutationVariables,
  CopyShiftTimesToUnitMutationCgResponse,
  CopyShiftTimesToUnitMutationVariables,
} from '@common/graphql';

export const COPY_SHIFT_TIMES_TO_UNITS_MUTATION: TypedDocumentNode<
  CopyShiftTimesToUnitMutationCgResponse,
  CopyShiftTimesToUnitMutationVariables
> = gql`
  mutation CopyShiftTimesToUnit(
    $input: CopyOrganizationUnitShiftTimesToUnitsInput!
  ) {
    copyShiftTimesToUnits(input: $input) {
      success
      errors {
        fullErrors
      }
    }
  }
`;

export const COPY_SHIFT_TIMES_FROM_UNIT_MUTATION: TypedDocumentNode<
  CopyShiftTimesFromUnitMutationCgResponse,
  CopyShiftTimesFromUnitMutationVariables
> = gql`
  mutation CopyShiftTimesFromUnit(
    $input: CopyOrganizationUnitShiftTimesFromUnitInput!
  ) {
    copyShiftTimesFromUnit(input: $input) {
      organizationUnitShiftConfigs {
        id
      }
    }
  }
`;
